var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.465 38.71c10.751 0 19.466-8.665 19.466-19.355C43.931 8.665 35.216 0 24.466 0 13.714 0 5 8.666 5 19.355c0 10.69 8.715 19.356 19.465 19.356zm4.257 3.27c1.25-.272 2.116-.46 2.296-.102.354.704-5.774 8.122-6.725 8.122-.95 0-7.078-7.418-6.724-8.122.18-.358 1.046-.17 2.296.101 1.208.263 2.776.603 4.428.603 1.653 0 3.22-.34 4.429-.603z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.456 25.408c.288.197.654.13 1.09-.147l3.722-2.387 3.73 2.387c.435.276.794.344 1.09.147.288-.19.352-.503.176-.945l-1.47-3.822 3.756-2.35c.437-.27.612-.558.5-.858-.113-.301-.443-.448-.985-.442l-4.609.03-1.4-3.84c-.169-.448-.422-.681-.788-.681-.358 0-.612.233-.78.681l-1.4 3.84-4.61-.03c-.54-.006-.872.141-.984.442-.12.3.063.589.5.858l3.756 2.35-1.47 3.822c-.176.442-.113.755.176.945z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFavorite);
export default __webpack_public_path__ + "static/media/pin-favorite.9fd44b04.svg";
export { ForwardRef as ReactComponent };